import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
import Subteacher from "@/components/Subteacher";
import TeacherDetail from "@/components/teacherInfo/TeacherDetail";
import About from "@/components/about/About";
import Video from "@/components/video/S-video";
import Wechat from "@/components/Wechat";
import SelfLearning from "@/components/SelfLearning";
import Studycenter from "@/components/Studycenter";
// import courseVideo from "@/components/video/courseVideo";


// import VideoList from "@/components/Information/VideoList.vue";
import newsRouter from './news.js'
import classpageRouter from './classpage.js'
import jiuyeRouter from './jiuye.js'
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        // {
        //     path: "*",
        //     redirect: '/mobile.html'
        // },
        {
            path: "/",
            redirect: '/mobile.html'
        },
        {
            path: "/mobile.html",
            name: "Index",
            component: Index,
            meta: { keepAlive: false }
        },
        {
            path: "/shizi.html",
            name: "Subteacher",
            component: Subteacher,
            meta: {
                title: '师资_51Testing软件测试培训网',
            },
        },
        {
            path: "/teacherDetail/:id" + '.html',
            name: "TeacherDetail",
            component: TeacherDetail,
            props: true,
        },
        {
            path: "/about.html",
            name: "About",
            component: About,
        },
        {
            path: "/video.html",
            name: "Video",
            component: Video,
                // meta: { keepAlive: true }

        },       
        {
            path: "/wechat.html",
            name: "Wechat",
            component: Wechat,
        },{
            path: "/selflearning.html",
            name: "SelfLearning",
            component: SelfLearning,
        },
        {
            path: "/studycenter.html",
            name: "Studycenter",
            component: Studycenter
        },
        ...newsRouter,
        ...classpageRouter,
        ...jiuyeRouter
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js